<template>
  <div>
    <dl class="row px-3 px-sm-5 pt-3 mb-0">
      <dt class="no-colon d-print-none w-xs-100">Aksiyon Seçiniz</dt>
      <dd class="single d-print-none w-xs-100 pl-1 pl-sm-0">
        <div class="form-group">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="idea-action"
              id="cbx-submit"
              data-target="#tab-form-approve"
              value="approve"
              v-model="evaluatorType"
            />
            <label class="form-check-label" for="cbx-submit">Değerlendir</label>
          </div>

          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="idea-action"
              id="cbx-return"
              data-target="#tab-form-return"
              value="return"
              v-model="evaluatorType"
            />
            <label class="form-check-label" for="cbx-return">Geri Gönder</label>
          </div>

          <div id="tab-form-approve" v-if="evaluatorType == 'approve'">
            <form
              action="/Admin/Update/5b677e5f-a0d9-eb11-bacb-000d3addce7f?updateType=1&amp;status=Evaluator"
              id="update-form"
              method="post"
            >
              <div class="row pl-5 mb-2 modal-bar">Fikir Değerlendirme</div>

              <div>
                <dl>
                  <div
                    v-for="category in doinPointStructureList"
                    :key="category.Id"
                    :value="category.Id"
                  >
                    <label style="width: 200px"
                      ><strong>{{ category.Name }}</strong>
                      <i
                        v-if="category.Description"
                        class="icon-question category-info"
                        :title="category.Description"
                      ></i
                    ></label>
                    <div
                      style="width: 100%"
                      class="form-check form-check-inline"
                      v-for="subCategory in category.SubCategories"
                      :key="subCategory.Id"
                      :value="subCategory.Id"
                    >
                      <div
                        style="width: 300px"
                        v-if="category.SubCategories.length === 2"
                        class="form-check form-check-inline"
                      >
                        <input
                          type="radio"
                          :id="'subcategory_' + subCategory.Id"
                          data-target="#tab-form-approve"
                          :value="'subcategory_' + subCategory.Id"
                          class="form-check-input"
                          :name="'category_' + category.Id"
                          :checked="
                            checkSelectedSubCategory(
                              category.Id,
                              subCategory.Id
                            )
                          "
                          @change="
                            selectedCategories(category.Id, subCategory.Id)
                          "
                        />
                        <label
                          :for="'subcategory_' + subCategory.Id"
                          class="form-check-label"
                          >{{ subCategory.Name }}</label
                        >
                      </div>

                      <div
                        style="width: 300px"
                        v-if="category.SubCategories.length > 2"
                        class="form-check form-check-inline"
                      >
                        <input
                          type="checkbox"
                          :id="'subcategory_' + subCategory.Id"
                          data-target="#tab-form-approve"
                          :value="subCategory.Id"
                          class="form-check-input"
                          :name="'category_' + category.Id"
                          v-model="selectedCheckboxes"
                          @change="checkboxChangeHandler(subCategory.Id)"
                        />
                        <label
                          :for="'subcategory_' + subCategory.Id"
                          class="form-check-label"
                          >{{ subCategory.Name }}</label
                        >
                      </div>
                      <div
                        v-if="
                          selectedCheckboxes.find((x) => x == subCategory.Id)
                        "
                        style="display: inline-flex"
                      >
                        <div
                          v-for="childCategory in subCategory.ChildCategories"
                          :key="childCategory.Id"
                          :value="childCategory.Id"
                        >
                          <div
                            style="
                              display: inline-flex;
                              align-items: center;
                              padding-left: 3px;
                            "
                          >
                            <input
                              type="radio"
                              :id="'childCategory_' + childCategory.Id"
                              data-target="#tab-form-approve"
                              :value="'childCategory_' + childCategory.Id"
                              class="form-check-input"
                              :name="'subcategory_' + subCategory.Id"
                              :checked="
                                checkSelectedChildCategory(
                                  category.Id,
                                  subCategory.Id,
                                  childCategory.Id
                                ) &&
                                selectedCheckboxes.find(
                                  (x) => x == subCategory.Id
                                )
                              "
                              v-show="selectedCheckboxes"
                              @change="
                                selectedCategories(
                                  category.Id,
                                  subCategory.Id,
                                  childCategory.Id
                                )
                              "
                            />
                            <label
                              :for="'childCategory_' + childCategory.Id"
                              class="form-check-label"
                              >{{ childCategory.Name }}</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="form-group invalid-feedback"
                      :style="[
                        requiredField.includes('category_' + category.Id)
                          ? { display: 'block' }
                          : '',
                      ]"
                    >
                      Bu alan boş geçilemez!
                    </div>
                  </div>
                </dl>
              </div>

              <div class="form-group icon-folder-alt icon-down">
                <select
                  class="form-control"
                  id="searchFilterValueCurrent"
                  name="ValueCurrent"
                  title="Tümü"
                  placeholder="Tümü"
                  v-model="valueCurrentId"
                  :disabled="detailData?.ValueCurrentId"
                >
                  <option value="">İlgili Alan Seçiniz</option>
                  <optgroup
                    v-for="item in currenValuelist"
                    :key="item.Name"
                    :label="item.Name"
                  >
                    <option
                      v-for="company in item.ValueCurrentDTOs"
                      :key="company.Id"
                      :value="company.Id"
                    >
                      {{ company.Name }}
                    </option>
                  </optgroup>
                </select>
              </div>
              <div
                id="drpValueCurrentError"
                class="form-group invalid-feedback"
                :style="[
                  requiredField.includes('valueCurrentId')
                    ? { display: 'block' }
                    : '',
                ]"
              >
                Bu alan boş geçilemez!
              </div>
              <div
                v-if="isSuggestionEvaluator"
                class="form-group icon-folder-alt icon-down"
              >
                <select
                  class="form-control"
                  data-val="true"
                  data-val-required="The Id field is required."
                  id="drpUser"
                  name="SuggestionDecisionMaker.Id"
                  validationelement="1"
                  v-model="suggestionEvaluator"
                >
                  <option
                    v-for="item in suggestionEvaluatorList"
                    :key="item.Id"
                    :value="item.Id"
                  >
                    {{ item.FullName }}
                  </option>
                </select>
              </div>
              <div
                v-if="isSuggestionEvaluator"
                id="drpUserError"
                class="form-group invalid-feedback"
                :style="[
                  requiredField.includes('suggestionEvaluator')
                    ? { display: 'block' }
                    : '',
                ]"
              >
                Bu alan boş geçilemez!
              </div>
              <template>
                <div class="form-group">
                  <textarea
                    class="form-control short"
                    cols="20"
                    id="SuggestionEvaluatorNote"
                    name="SuggestionEvaluatorNote"
                    placeholder="Fikir Değerlendirme Açıklaması"
                    rows="2"
                    v-model="suggestionEvaluatorNote"
                  ></textarea>
                </div>
                <div
                  class="form-group invalid-feedback"
                  :style="[
                    requiredField.includes('suggestionEvaluatorNote')
                      ? { display: 'block' }
                      : '',
                  ]"
                >
                  Bu alan boş bırakılamaz, karakter sayısını arttırarak tekrar
                  deneyiniz.
                </div>

                <div class="form-group icon-folder-alt icon-down">
                  <select
                    class="form-control"
                    id="drpSuggestedApplication"
                    name="SuggestedApplication"
                    validationelement="1"
                    v-model="suggestedApplication"
                  >
                    <option value="">Uygulama Önerisini Seçiniz</option>
                    <option value="1">Projelendirilsin</option>
                    <option value="2">Hemen Uygulama</option>
                    <option value="3">Red</option>
                  </select>
                </div>
                <div
                  id="drpSuggestedApplicationError"
                  class="form-group invalid-feedback"
                  :style="[
                    requiredField.includes('suggestedApplication')
                      ? { display: 'block' }
                      : '',
                  ]"
                >
                  Bu alan boş geçilemez!
                </div>
                <div class="form-group decider-multiselect-wrapper">
                  <multiselect
                    v-model="suggestedTeamLeader"
                    tag-placeholder="Add this as new tag"
                    placeholder="Ekip Lideri Önerisi Seçiniz"
                    label="Name"
                    track-by="Id"
                    :options="optionSuggestedTeamLeader"
                    :searchable="true"
                    style="padding: 0"
                    selectLabel="Seçmek için tıklayınız"
                    selectedLabel="Seçildi"
                    deselectLabel="Silmek için tıklayınız"
                  >
                  </multiselect>
                </div>
              </template>
              <div class="insider-form-button pb-2 pt-3">
                <button
                  type="button"
                  class="btn-innovation-radius bg-orange Roboto-Bold py-2 px-4 mr-3"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="removeValue"
                >
                  VAZGEÇ
                </button>
                <button
                  type="button"
                  id="btnSendUpdate"
                  class="btn-innovation-radius bg-blue-1 Roboto-Bold py-2 px-4 mr-3"
                  @click="sendUpdate(true)"
                  :disabled="isBtnDisabled"
                >
                  KAYDET
                </button>
                <button
                  type="button"
                  id="btnSendUpdate"
                  class="btn-innovation-radius bg-blue-1 Roboto-Bold py-2 px-4"
                  @click="sendUpdate(false)"
                  :disabled="isBtnDisabled"
                >
                  GÖNDER
                </button>
              </div>
            </form>
          </div>
          <div id="tab-form-return" v-if="evaluatorType == 'return'">
            <form
              action="/Admin/Update/5b677e5f-a0d9-eb11-bacb-000d3addce7f?isReturn=True&amp;status=Distributer"
              method="post"
            >
              <div class="form-group">
                <textarea
                  class="form-control"
                  cols="20"
                  id="ReasonForReturn"
                  name="ReasonForReturn"
                  placeholder="Geri gönderme nedenini giriniz"
                  required="required"
                  rows="2"
                  v-model="reasonForReturn"
                ></textarea>
              </div>
              <div
                class="form-group invalid-feedback"
                :style="[isReasonForReturn ? { display: 'block' } : '']"
              >
                Bu alan boş bırakılamaz, karakter sayısını arttırarak tekrar
                deneyiniz.
              </div>
              <div class="insider-form-button pb-2 pt-3">
                <button
                  type="button"
                  class="btn-innovation-radius bg-orange Roboto-Bold py-2 px-4 mr-3"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="clearReturnValue"
                >
                  VAZGEÇ
                </button>
                <button
                  type="button"
                  class="btn-innovation-radius bg-blue-1 Roboto-Bold py-2 px-4"
                  @click="openReturnModal"
                  :disabled="isBtnDisabled"
                >
                  GÖNDER
                </button>
              </div>
            </form>
          </div>
        </div>
      </dd>
    </dl>
    <transition name="fade">
      <div
        v-if="isReturnModal"
        id="Warning"
        class="modal fade show"
        style="height: 300px; display: block"
        role="dialog"
        data-backdrop="false"
      >
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
              <p>
                Geri gönderme işlemi, fikri bir önceki adıma geri gönderir ve
                farklı bir departmanın değerlendirmesine sunulur. Fikrin sizin
                departmanınızla ilgisi olmadığını düşünüyorsanız “Geri Gönder”
                seçeneğine basınız. Fikir detayına geri dönmek için “İptal”
                seçeneğine basınız.
              </p>
              <button
                type="button"
                class="btn btn-danger confirmclosed"
                style="margin-left: 27%"
                @click.stop="exitModal"
              >
                İptal
              </button>
              <button
                type="button"
                class="btn btn-primary ml-2"
                @click="sendReasonForReturn"
                :disabled="isBtnDisabled"
              >
                Geri Gönder
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import "../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css";
import { suggestionService } from "../../../services";
export default {
  name: "Evaluation",
  data() {
    return {
      requiredField: [],
      evaluatorType: "",
      subEvaluatorType: "",
      childEvaluatorType: "",
      currenValuelist: [],
      suggestionSubject: "",
      valueCurrentId: "",
      aboutProblem: "",
      aboutSuggestion: "",
      suggestedApplication: "",
      suggestedTeam: "",
      workHour: "",
      suggestionEvaluatorNote: "",
      suggestionEvaluator: "",
      isBtnDisabled: false,
      reasonForReturn: "",
      suggestionEvaluatorList: [],
      isReasonForReturn: false,
      mainDoinCategoryId: 0,
      subDoinCategoryIds: [],
      doinSubCategoryList: [],
      doinPointList: [],
      doinPointStructureList: [],
      selectedSubCategory: null,
      selectedCheckboxes: [], // Seçilen alt kategorileri saklamak için dizi
      maxSelections: 2, // Maksimum seçim sayısı
      totalPoints: 0, //toplam puan
      selectedSubCategories: [],
      isReturnModal: false,
      minLengthForText: 4,
      suggestedTeamLeader: "",
      optionSuggestedTeamLeader: [],
    };
  },
  watch: {
    valueCurrentId() {
      if (this.valueCurrentId) this.getManagerByValueCurrentId();
    },
    getUsers: {
      handler: function (val) {
        // Return the object that changed
        val.forEach((element) => {
          this.setUsers(element);
        });
      },
      deep: true,
    },
  },
  components: {
    Multiselect,
  },
  props: {
    isSuggestionEvaluator: {
      type: Boolean,
      default: true,
    },
    detailData: {
      type: Object,
    },
    typeId: {
      type: Number,
    },
    selectedDoinList: {
      type: Array,
    },
  },
  computed: {
    ...mapGetters({
      user: "user/user",
    }),
    gettersValueCurrents() {
      return this.$store.getters["suggestion/getValueCurrents"];
    },
    getUsers() {
      return this.$store.getters["user/getUsers"];
    },
  },
  async created() {
    if (!this.getUsers) {
      await this.$store.dispatch("user/getUsers");
    } else {
      this.getUsers.forEach((element) => {
        this.setUsers(element);
      });
    }
    await this.getValueCurrents();
    await this.getDoinPointStructureList();
    this.suggestionSubject = this.detailData.SuggestionSubjectId;
    this.valueCurrentId = this.detailData.ValueCurrentId;
    this.mainDoinCategoryId = this.detailData.MainDoinCategoryId;
    this.subDoinCategoryIds = this.detailData.SubDoinCategoryIds ?? [];
    this.selectedDoinList.forEach((value) => {
      if (value.ChildCategoryId) {
        this.selectedCheckboxes.push(value.SubCategoryId);
      }
      this.selectedSubCategories.push({
        mainCategoryId: value.MainCategoryId,
        subCategoryId: value.SubCategoryId,
        childCategoryId: value.ChildCategoryId,
      });
    });
    this.suggestionEvaluatorNote = this.detailData.SuggestionEvaluatorNote;
    this.suggestedApplication = this.detailData.SuggestedApplicationId;
    this.suggestionEvaluator = this.detailData.SuggestionDecisionMakerId;
    if (this.detailData.SuggestedTeamLeaderId) {
      this.suggestedTeamLeader = {
        Name: this.detailData.SuggestedTeamLeaderName,
        Id: this.detailData.SuggestedTeamLeaderId,
      };
    }
  },
  methods: {
    setUsers(element) {
      this.optionSuggestedTeamLeader.push({
        Name: element.FullName + " (" + element.CompanyName + ")",
        Id: element.Id,
      });
    },
    exitModal() {
      this.isReturnModal = false;
    },
    openReturnModal() {
      if (
        this.reasonForReturn &&
        this.reasonForReturn.trim().length > this.minLengthForText
      ) {
        this.isReturnModal = true;
      } else {
        this.isReasonForReturn = true;
      }
    },
    async getValueCurrents() {
      if (
        !this.gettersValueCurrents ||
        this.gettersValueCurrents?.length == 0
      ) {
        await this.$store.dispatch("suggestion/getValueCurrentsData");
      }
      this.currenValuelist = this.gettersValueCurrents;
    },
    removeValue() {
      this.suggestionSubject = "";
      this.valueCurrentId = "";
      this.aboutProblem = null;
      this.aboutSuggestion = null;
      this.suggestedApplication = "";
      this.suggestedTeam = null;
      this.workHour = null;
      this.suggestionEvaluatorNote = "";
      this.suggestionEvaluator = "";
      this.$emit("on-remove-value");
    },
    checkDoinCategoryValidations() {
      let isRequired = true;
      this.doinPointStructureList.forEach((category) => {
        if (
          this.selectedSubCategories.length == 0 ||
          !this.selectedSubCategories.find(
            (x) => x.mainCategoryId == category.Id
          )
        ) {
          isRequired = false;
        }
      });

      this.selectedCheckboxes.forEach((item) => {
        if (!this.selectedSubCategories.find((x) => x.subCategoryId == item)) {
          isRequired = false;
        }
      });
      return isRequired;
    },
    async sendUpdate(isDraft) {
      this.requiredField = [];
      if (
        this.checkDoinCategoryValidations() &&
        this.suggestionEvaluatorNote &&
        this.suggestionEvaluatorNote.trim().length > this.minLengthForText &&
        this.suggestedApplication != "" &&
        this.valueCurrentId != "" &&
        ((this.isSuggestionEvaluator && this.suggestionEvaluator != "") ||
          (!this.isSuggestionEvaluator && this.suggestionEvaluator == ""))
      ) {
        this.isBtnDisabled = true;
        await this.$store.dispatch("loading/setIsLoading", true);
        const tmpData = {
          suggestionSubject: this.suggestionSubject,
          valueCurrentId: this.valueCurrentId,
          aboutProblem: this.aboutProblem,
          aboutSuggestion: this.aboutSuggestion,
          suggestedApplication: this.suggestedApplication,
          suggestedTeam: this.suggestedTeam,
          workHour: this.workHour,
          suggestionEvaluatorNote: this.suggestionEvaluatorNote,
          suggestionEvaluator: this.suggestionEvaluator,
          doinCategories: this.selectedSubCategories,
          isDraft: isDraft,
          suggestedTeamLeaderId: this.suggestedTeamLeader.Id,
        };

        this.suggestionEvaluator
          ? (tmpData.suggestionEvaluator = this.suggestionEvaluator)
          : "";
        tmpData.callback = async () => {
          this.isBtnDisabled = false;
          await this.$store.dispatch("loading/setIsLoading", false);
        };
        await this.$emit("send-update", tmpData);
      } else {
        if (this.suggestedApplication == "")
          this.requiredField.push("suggestedApplication");
        if (
          !this.suggestionEvaluatorNote ||
          this.suggestionEvaluatorNote.trim().length <= this.minLengthForText
        )
          this.requiredField.push("suggestionEvaluatorNote");
        if (this.valueCurrentId == "")
          this.requiredField.push("valueCurrentId");
        if (this.suggestionEvaluator == "")
          this.requiredField.push("suggestionEvaluator");
        this.doinPointStructureList.forEach((category) => {
          if (
            this.selectedSubCategories.length == 0 ||
            !this.selectedSubCategories.find(
              (x) => x.mainCategoryId == category.Id
            )
          ) {
            this.requiredField.push("category_" + category.Id);
          }
        });

        this.selectedCheckboxes.forEach((item) => {
          if (
            !this.selectedSubCategories.find((x) => x.subCategoryId == item)
          ) {
            this.doinPointStructureList.forEach((c) => {
              if (c.SubCategories.find((s) => s.Id == item)) {
                this.requiredField.push("category_" + c.Id);
              }
            });
          }
        });
      }
    },
    clearReturnValue() {
      this.reasonForReturn = null;
      this.$emit("on-clear-return-value");
    },
    async sendReasonForReturn() {
      if (
        this.reasonForReturn &&
        this.reasonForReturn.trim().length > this.minLengthForText
      ) {
        this.isBtnDisabled = true;
        await this.$store.dispatch("loading/setIsLoading", true);
        this.$emit("send-reason-return", {
          reasonForReturn: this.reasonForReturn,
          callback: async () => {
            this.isBtnDisabled = false;
            this.isReasonForReturn = false;
            await this.$store.dispatch("loading/setIsLoading", false);
          },
        });
      } else {
        this.isReasonForReturn = true;
      }
    },
    async getManagerByValueCurrentId() {
      const isEvaluator = false;
      const isDecider = true;
      try {
        const res = await suggestionService.fetchGetManagerByValueCurrentId(
          this.user.Data.CompanyId,
          this.valueCurrentId,
          isEvaluator,
          isDecider,
          this.typeId
        );
        this.suggestionEvaluatorList = [
          { Id: "", FullName: "Fikir Karar Vericiyi Seçiniz" },
          ...res.Data,
        ];
      } catch (error) {
        //console.log(error);
      }
    },
    async getDoinPointStructureList() {
      try {
        const res = await suggestionService.fetchGetDoinPointStructureList();
        this.doinPointStructureList = res.Data?.filter(
          (x) =>
            !(
              (x.StartDate &&
                new Date(x.StartDate) >
                  new Date(this.detailData.SuggestionDate)) ||
              (x.EndDate &&
                new Date(x.EndDate) < new Date(this.detailData.SuggestionDate))
            )
        );
      } catch (error) {
        //console.log(error);
      }
    },
    checkboxChangeHandler(subCategoryId) {
      if (this.selectedCheckboxes.length > this.maxSelections) {
        let unselectedSubCategoryId = this.selectedCheckboxes.shift(); //ilk seçileni kaldırabilirsiniz
        this.selectedSubCategories = this.selectedSubCategories.filter(
          (e) => e.subCategoryId !== unselectedSubCategoryId
        );
      }
      this.selectedSubCategories = this.selectedSubCategories.filter(
        (e) => e.subCategoryId !== subCategoryId
      );
    },
    selectedCategories(mainCategoryId, subCategoryId, childCategoryId) {
      let entity = {
        mainCategoryId: mainCategoryId,
        subCategoryId: subCategoryId,
        childCategoryId: childCategoryId,
      };
      if (
        this.selectedSubCategories.find(
          (e) => e.mainCategoryId === mainCategoryId
        ) &&
        !childCategoryId
      ) {
        this.selectedSubCategories = this.selectedSubCategories.filter(
          (e) => e.mainCategoryId !== mainCategoryId
        );
      } else if (
        this.selectedSubCategories.find(
          (e) => e.mainCategoryId === mainCategoryId
        ) &&
        childCategoryId
      ) {
        this.selectedSubCategories = this.selectedSubCategories.filter(
          (e) => e.subCategoryId !== subCategoryId
        );
      }
      this.selectedSubCategories.push(entity);
      //this.checkboxChangeHandler();
    },
    checkSelectedSubCategory(categoryId, subCategoryId) {
      return this.selectedSubCategories?.find(
        (e) =>
          e.mainCategoryId === categoryId && e.subCategoryId === subCategoryId
      );
    },
    checkSelectedChildCategory(categoryId, subCategoryId, childCategoryId) {
      return this.selectedSubCategories?.find(
        (e) =>
          e.mainCategoryId === categoryId &&
          e.subCategoryId === subCategoryId &&
          e.childCategoryId === childCategoryId
      );
    },
  },
};
</script>